import { Outlet } from "react-router-dom";

const AuthLayout = () => {
  return (
    <main
      id="Main"
      className="fixed left-0 top-0 h-[var(--app-height,100dvh)] w-screen pt-[env(safe-area-inset-top,0px)] transition-[height] duration-200 ease-out motion-reduce:transition-none lg:flex"
    >
      <Outlet />
    </main>
  );
};

export default AuthLayout;
